import { gql } from '@apollo/client';

export const ADD_MUSCLE_GROUP = gql`
    mutation addMuscleGroup($muscleGroupInput: MuscleGroupInput!){
        addMuscleGroup(muscleGroupInput: $muscleGroupInput) {
            _id
        }
    }
`;
